
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface ServiceToggleProps {
  label: string;
  description: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const ServiceToggle = ({ 
  label, 
  description, 
  checked, 
  onCheckedChange, 
  disabled 
}: ServiceToggleProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="space-y-0.5">
        <Label>{label}</Label>
        <p className="text-sm text-muted-foreground">
          {description}
        </p>
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
    </div>
  );
};
